import React from 'react';

// login and registration
import LoginPage from './components/create-account/login-page/login-page.component';
import CreateAccPage from './components/create-account/create-acc-page/create-acc-page.component';
import EmailConfirmationPage from './components/create-account/email-conf-page/email-conf-page.component';
import RegistrationPage from './components/create-account/registration-page/registration-page.component';
import ForgetPasswordPage from './components/create-account/forget-password-page/forget-password-page.component';
import ResetPassword from './components/create-account/reset-password-page/reset-password-page.component';

import Auth from './Auth';
import HomePage from './components/homepage/homepage.component';

// Applicant pages
import CreateBiography from './components/applicant/create-biography/create-biography.component';
import Biographies from './components/applicant/biographies/biographies.component';
import ApplicantProfile from './components/applicant/applicant-profile/applicant.profile.component';
import AppliedAndSavedJobs from './components/applicant/applied-saved-jobs/applied-saved-jobs.component';
import SearchResults from './components/applicant/search/search-results.component';
import ApplyJob from './components/applicant/job-apply/apply-job.component';
// Employer or company pages
import JobDetails from './components/company/jobs/job-details.component';
import CompanyProfileReg from './components/company/company-profile/company-profile-reg.component';
import CompanyProfile from './components/company/company-profile/company-profile.component';
import CreateJob from './components/company/jobs/create-job.component';
import Jobs from './components/company/jobs/jobs.component';
import ApplicantProfileForCompany from './components/company/applicant-profile-for-company/applicant-profile.component';
// common pages
import Notifications from './components/notifications/all-notifications.component';
import Messages from './components/messages/index.component';
import Header from './components/header/header.component';
import Footer from './components/footer/footer.component';
// styles
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import 'bootstrap/dist/css/bootstrap.min.css';



import {
   //   BrowserRouter as Router,
   Switch,
   Route,
   HashRouter
} from "react-router-dom";

import './App.css';



const theme = createMuiTheme({
   palette: {
      primary: { main: '#E85A19', light: '#fff', dark: '#ea5f11' },
      secondary: { main: '#fff', light: '#000', dark: '#f1eeee' },
      contrastText: { main: '#E1631C' },
   },
   typography: {
      fontSize: 13,
      button: {
         textTransform: 'none',
         fontSize: 10,
      }
   }
});

function App() {

   return (
      <ThemeProvider theme={theme}>
         <HashRouter>
         
            <Switch>
               <Route exact path="/">
                  <LoginPage />
               </Route>
               <Route exact path="/createAccount">
                  <CreateAccPage />
               </Route>
               <Route exact path="/emailConfirmation">
                  <EmailConfirmationPage />
               </Route>
               <Route exact path="/registration">
                  <RegistrationPage />
               </Route>
               <Route exact path="/forgetPassword">
                  <ForgetPasswordPage />
               </Route>
               <Route exact path="/resetPassword">
                  <ResetPassword />
               </Route>
               <>
               <Route  render={props => <Auth><Header {...props} /></Auth>} />
                  <Route exact path="/companyProfileReg">
                     <CompanyProfileReg />
                  </Route>
                  <Route exact path="/companyProfile">
                     <CompanyProfile />
                  </Route>
                  <Route exact path="/createJob">
                     <CreateJob />
                  </Route>
                  <Route path="/searchResults">
                     <SearchResults />
                  </Route>
                  <Route path="/jobApply">
                     <ApplyJob />
                  </Route>
                  <Route path="/notifications">
                     <Notifications />
                  </Route>
                  <Route path="/messages">
                     <Messages />
                  </Route>
                  <Route exact path="/jobs" render={props => <Auth><Jobs {...props} /></Auth>} />
                  <Route exact path="/jobDetails/:id" render={props => <Auth><JobDetails {...props} /></Auth>} />
                  <Route exact path="/homepage" render={props => <Auth><HomePage {...props} /></Auth>} />
                  <Route exact path="/visumes" render={props => <Auth><Biographies {...props} /></Auth>} />
                  <Route exact path="/createVisume" render={props => <Auth><CreateBiography {...props} /></Auth>} />
                  <Route exact path="/profile" render={props => <Auth><ApplicantProfile {...props} /></Auth>} />
                  <Route exact path="/myJobs" render={props => <Auth><AppliedAndSavedJobs {...props} /></Auth>} />
                  <Route exact path="/applicantProfile/:id" render={props => <Auth><ApplicantProfileForCompany {...props} /></Auth>} />
                  {/* <Route exact path="/notifications" render={props => <Auth><Notifications {...props} /></Auth>} /> */}
               </>
            </Switch>
            <Footer/>
         </HashRouter>
      </ThemeProvider>

   );
}

export default App;

